import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { MusicalWorkView } from "./MusicalWorkView";
import { MusicalWorkViewStore } from "../../store/MusicalWorkViewStore";
import { useStore } from "../../../../hooks";

export const MusicalWorkViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/musicalWork/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new MusicalWorkViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "workInfo",
              label: rootStore.langStore.groupMusicalWorkWorkInfoLabel,
            },
            {
              id: "workRegistration",
              label: rootStore.langStore.groupMusicalWorkWorkRegistrationLabel,
            },
            {
              id: "workContent",
              label: rootStore.langStore.groupMusicalWorkWorkContentLabel,
            },
            {
              id: "contracts",
              label: rootStore.langStore.groupMusicalWorkContractsLabel,
            },
            {
              id: "systemDates",
              label: rootStore.langStore.groupMusicalWorkSystemDatesLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <MusicalWorkView musicalWorkViewStore={store} />
      </PageLayout>
    </div>
  );
});
